"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomClearedEventArgs = void 0;
const EventType_1 = require("../EventType");
class RoomClearedEventArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = EventType_1.EventType.RoomCleared;
        this.__typeName = "RoomCleared";
    }
}
exports.RoomClearedEventArgs = RoomClearedEventArgs;
